import styled from "@emotion/styled";
import { LinearProgress, Theme, linearProgressClasses } from "@mui/material";

export const BorderLinearProgress = styled(LinearProgress)(
  ({ theme }: any) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor:
        theme.palette.mode === "light" ? theme.palette.primary.main : "#308fe8",
    },
  })
);
